
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/which-ai-chat-ui-is-best-for-research",
      function () {
        return require("private-next-pages/which-ai-chat-ui-is-best-for-research.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/which-ai-chat-ui-is-best-for-research"])
      });
    }
  